import { ImpactModule } from 'types'
import { INVENTORY_PAGES } from './pages'
import { INVENTORY_PAGES_ORDER_FOR_PERMISSIONS } from './pagesOrderForPermissions'

export const INVENTORY_MODULE: ImpactModule = {
  NAME: 'object',
  NAME_PTBR: 'Estoque',
  UPPER_NAME: 'ADMIN',
  API_NAME: 'ADMIN',
  PAGES: INVENTORY_PAGES,
  PAGES_ORDER_FOR_PERMISSIONS: INVENTORY_PAGES_ORDER_FOR_PERMISSIONS,
}
